var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about mx-auto mt-5",staticStyle:{"width":"90%"}},[_c('AboutMe'),_c('ContactMe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }